import { LogTypes } from '@audibene/ta-browser-tracker'
import { logRocket } from 'startup/logRocket'
import type { RequestFailure } from 'utils'
import { getNewRelicTracker } from './newRelic'
import { isLiveEnvironment } from './processEnv'

/**
 * Reports a failed service request to every monitoring channel so we can see
 * which backend is unstable and act on it. Registered as the request-failure
 * reporter at startup. See PX-3333.
 */
const reportServiceError = ({ kind, status, url }: RequestFailure): void => {
  const { host, pathname } = new URL(url)
  const message = `Service request failed: ${host}${pathname} (${kind}${status ? ` ${status}` : ''})`
  const attributes = { kind, pathname, service: host, status }

  // Console only outside live environments, where LogRocket and New Relic are
  // the real channels; avoids per-retry console noise in production.
  if (!isLiveEnvironment) {
    // eslint-disable-next-line no-console
    console.warn(message, attributes)
  }

  // Safely no-ops until LogRocket is initialized.
  logRocket.log(LogTypes.ERROR, message, attributes)

  // New Relic's log throws before init, so guard on it explicitly.
  const newRelicTracker = getNewRelicTracker()

  if (newRelicTracker?.isInitialized()) {
    newRelicTracker.log(LogTypes.ERROR, message, attributes)
  }
}

export { reportServiceError }
